import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { GreetingsApi } from 'entities/Greetings/api/greetings.ts'
import { Attachment } from 'entities/Attachment/model/Attachment.ts'
import { type IResponseVoiceGreeting } from 'entities/Greetings/api/types.ts'
import { cacheStore } from 'entities/Cache/CacheStore.ts'

export class GreetingStore {
  constructor() {
    makeAutoObservable(this)
  }

  private _itemsMap: Map<number, Attachment> = new Map()
  get attachments() {
    return Array.from(this._itemsMap.values())
  }

  getAttachment = (id: number) => {
    return this._itemsMap.get(id)
  }

  private _addGreeting = (item: IResponseVoiceGreeting) => {
    const attachment = new Attachment({
      responseVoiceGreeting: item,
      isGenerateExtensionName: true,
    })
    this._itemsMap.set(item.id, attachment)
    return attachment
  }
  loadGreetings = async () => {
    try {
      const { data } = await cacheStore.getSingletonData(GreetingsApi.getVoiceGreetings)()
      this._itemsMap.clear()
      return data.map(this._addGreeting)
    } catch (e) {
      logger.error(e)
    }
  }

  uploadGreeting = async (file: File): Promise<Attachment> => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('name', file.name)
    const { data } = await GreetingsApi.uploadVoiceGreeting(formData)
    return this._addGreeting(data)
  }

  deleteGreeting = async (id: number) => {
    await GreetingsApi.deleteVoiceGreeting(id)
    this._itemsMap.delete(id)
  }
  deleteGreetings = async (ids: number[]) => {
    await Promise.all(ids.map((id) => this.deleteGreeting(id)))
  }

  updateVoiceGreetingName = async (attachment: Attachment, name: string) => {
    const { data } = await GreetingsApi.updateVoiceGreetingName(Number(attachment.id), { name })
    attachment.setName(name)
    return this._addGreeting(data)
  }
}
